import Loading from "components/Event/Loading";
import { Grid2x2, Menu } from "lucide-react";
import React, { memo, useState } from "react";
import { Container, Row, Col, Card, Form } from "react-bootstrap";

const Main = memo(
  ({
    images,
    loading,
    loadingImages,
    searchTerm,
    searchHandle,
    loadMoreImages,
    loadingMore,
    expanded,
    setExpanded
  }) => {
    const [showType, setShowType] = useState(false);

    return (
      <Container fluid>
        {images.length >= 0 && (
          <div className="">

            <div className="d-flex justify-content-end align-items-center my-3">
              <div
                className="d-flex align-items-center"
                style={{ paddingInline: "20px", gap: "25px" }}
              >
                <Form.Control
                  type="text"
                  style={{ width: "300px" }}
                  placeholder="Search images..."
                  value={searchTerm}
                  onChange={searchHandle}
                  className="form-control form-control-sm " // Use me-3 for margin-end
                />

                <button
                  onClick={() => setShowType(!showType)}
                  className="btn btn-sm btn-dark " // Use me-2 for margin-end
                >
                  {showType ? <Menu /> : <Grid2x2 />}
                </button>

                <div className="d-flex align-items-center">
                  <span className="me-1">Total:</span> {/* Label for Total */}
                  <p className="mb-0">{images.length}</p> {/* Count */}
                </div>
              </div>
            </div>
          </div>
        )}

        <Row>
          {showType
            ? images.map((image, index) => (
              <Col xs={12} sm={6} md={3} key={`${image.url}-${index}`}>
                <Card className="mb-3">
                  <div
                    style={styles.gridImageCard}
                    onClick={() => window.open(image.url, "_blank")}
                  >
                    <img
                      src={image.url}
                      alt={image.name}
                      style={{ width: "100%" }}
                      loading="lazy"
                      onError={(e) => {
                        e.target.src = image.url; // Fallback if error
                      }}
                    />
                  </div>
                  <div style={styles.gridImageNameDiv}>
                    <p style={styles.imageName} >
                      {image.name}
                    </p>
                  </div>
                </Card>
              </Col>
            ))
            : images.map((image, index) => (
              <Col xs={12} sm={6} md={3} key={`${image.url}-${index}`}>
                <div
                  style={styles.barImageCard}
                  onClick={() => window.open(image.url, "_blank")}
                >
                  <p style={styles.imageName} >
                    {image.name}
                  </p>
                </div>
              </Col>
            ))}

          {images.length === 0 && !loadingImages && (
            <Col
              xs={12}
              className="d-flex justify-content-center align-items-center"
              style={{ height: "100vh" }}
            >
              <p>No images available.</p>
            </Col>
          )}

          {loadingMore ? (
            <Col
              xs={12}
              className="d-flex justify-content-center align-items-center my-4"
            >
              <Loading />
            </Col>
          ) : (
            images.length >= 500 && (
              <Col xs={12} className="text-center my-4">
                <button
                  onClick={loadMoreImages}
                  className="btn btn-sm btn-outline-secondary"
                >
                  Load More
                </button>
              </Col>
            )
          )}
        </Row>
      </Container>
    );
  }
);
const styles = {
  imageName: {
    margin: "0",
    fontSize: "0.9rem",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  barImageCard: {
    border: "1px solid #ccc",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    padding: "8px 15px",
    margin: "8px 0px",
    borderRadius: "5px",
    cursor: "pointer",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  gridImageNameDiv: {
    border: "1px solid #ccc",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    padding: "10px 15px",
    marginTop: "5px",
    borderRadius: "5px",
  },
  gridImageCard: {
    aspectRatio: "1/1",
    backgroundColor: "#fff",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    maxWidth: "100%",
    position: "relative",
    overflow: "hidden", // Hide overflow
    cursor: "pointer",
  }
}

export default Main;
